var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOutline(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 26,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning-outline_svg__svg-2192081076-a",
    d: "M17.105 1.2c.526.325.97.769 1.295 1.295l10.153 16.4a4 4 0 01-3.401 6.107H4.847a4 4 0 01-3.401-6.106l10.152-16.4a4 4 0 015.507-1.297zm-3.697 2.189l-.11.159-10.152 16.4a2.001 2.001 0 001.508 3.044l.193.01h20.305a2 2 0 001.794-2.885l-.093-.169L16.7 3.548a1.989 1.989 0 00-.495-.543l-.153-.105a2 2 0 00-2.644.489zM15 17a1.667 1.667 0 110 3.334A1.667 1.667 0 0115 17zm0-9.83c.506 0 .925.376.99.864l.01.136v5.944a1 1 0 01-1.99.135l-.01-.135V8.17a1 1 0 011-1z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#C42B44",
    xlinkHref: "#warning-outline_svg__svg-2192081076-a",
    fillRule: "evenodd"
  })));
}
export default SvgWarningOutline;